module.exports = __webpack_public_path__ + "media/images/lp_v6_oka-587d273d115d3138fea263401d327bff.webp";